module.exports = __webpack_public_path__ + "files/0727bb3342908430fdd06dad755e3946.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-13.png
// module id = 1502
// module chunks = 60